import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const autogenDocPlugin = createPlugin({
  id: 'autogen-doc',
  routes: {
    root: rootRouteRef,
  },
});

export const AutoGenDocPage = autogenDocPlugin.provide(
  createRoutableExtension({
    name: 'AutoGenDocPage',
    component: () =>
      import('./components/AutoGenDocComponent').then(
        m => m.AutoGenDocComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);
